import React from 'react';
import {
  Box,
  TextField,
  CircularProgress,
  TextFieldProps,
} from '@mui/material';

import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

import { styles, getTextFieldSx } from './styles';

type Props = {
  success?: boolean;
  loading?: boolean;
  name?: string;
  helperText2?: string | null;
  letterSpacing?: number;
  allowEmptyFormatting?: boolean;
  autocomplete?: string;
} & TextFieldProps;

const CustomTextField = ({
  success,
  helperText2,
  error,
  loading,
  value,
  variant = 'outlined',
  letterSpacing = 0,
  ...rest
}: Props) => {
  const inputProps = rest.InputProps;
  const inputLabelProps = rest.InputLabelProps;

  const getHelperText = () => {
    if (helperText2) {
      return <span>{helperText2}</span>;
    }
    if (error) {
      return <span>{error}</span>;
    }
    return undefined;
  };

  return (
    <TextField
      error={error}
      helperText={getHelperText()}
      variant={variant}
      color={success ? 'secondary' : 'primary'}
      sx={getTextFieldSx(letterSpacing)}
      value={value ? value : ''}
      InputLabelProps={{
        ...inputLabelProps,
        disableAnimation: inputLabelProps?.disableAnimation ?? true,
        shrink: inputLabelProps?.shrink ?? false,
        sx: {
          ...styles.label,
          ...(typeof inputLabelProps?.sx === 'object' &&
          !Array.isArray(inputLabelProps.sx)
            ? inputLabelProps.sx
            : {}),
        },
      }}
      InputProps={{
        ...inputProps,
        endAdornment: success ? (
          <CheckCircleOutlineRoundedIcon />
        ) : error ? (
          <ErrorOutlineRoundedIcon color={'error'} />
        ) : loading ? (
          <Box>
            <CircularProgress size={20} />
          </Box>
        ) : (
          ''
        ),
      }}
      {...rest}
    />
  );
};

export default CustomTextField;
